import React from "react";
import { TypeBadgeProps } from "../../interfaces/components/typeBadge";
import { Type } from "../../shared/utils/enums";

const TypeBadge: React.FC<TypeBadgeProps> = ({ type }) => {
  const getTypeStyles = () => {
    switch (type) {
      case Type.DOCUMENT:
        return "text-blue-700 bg-blue-100";
      case Type.FEATURE:
        return "text-green-700 bg-green-100";
      case Type.BUG:
        return "text-red-700 bg-red-100";
      default:
        return "text-gray-700 bg-gray-100";
    }
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${getTypeStyles()}`}
    >
      {type}
    </span>
  );
};

export default TypeBadge;
